import React, { Component } from 'react'

import './style.scss'

class ProjectUnit extends Component {
  render() {
    return (
      <div className="experience-unit col-xs-12 col-sm-6 col-md-4">
      <a href={this.props.link} target="_blank">
        <div
          className="image"
          style={{
            backgroundImage: `url(${this.props.logo})`,
            backgroundColor: this.props.colour
          }}>
        </div>
          </a>
          <div className="title bold">
            {this.props.title}
              &emsp;
              <a href={this.props.githubLink} target="_blank">
                <i className="fa fa-github fa-2x" id="githubIcon"></i>
              </a>
          </div>
          <div className="time-period">
            {this.props.timeperiod}
          </div>
          <div className="subtitle">
            {this.props.subtitle}
          </div>
          <div className = "technologies">
          </div>
        </div>
  )
}
}

export default ProjectUnit


// WEBPACK FOOTER //
// ./src/components/ProjectUnit/index.js